module.exports = __webpack_public_path__ + "static/media/NTU EEE Alumni Association.aabe4909.png";